<section class="container" hidden>
        <div class="login">
          <h2>Login</h2>
            <p><input #userId type="text" placeholder="{{bs.getResource('userName')}}" value="admin"></p>
            <p><input #password type="password" placeholder="{{bs.getResource('password')}}" value="password" (keyup.enter)="validateLogin(userId.value, password.value)"></p>
            <p class="submit" (click)="validateLogin(userId.value, password.value)"><button > Login </button>
            </p>
            <div *ngIf="error['err']">
                <app-error-view [prepareError]="error"></app-error-view>
            </div>
        </div>
    </section>
    <app-footer></app-footer>